export default {
   maxWidth: '100%',
   width: '100%',
}